import { isValidElement, ReactNode } from "react";

/**
 * Best-effort plain text for a `ReactNode`, for the places that need a real string rather than a node
 * (tooltip titles, `aria-label`). Walks element children so wrapped content (e.g. `<span>Name</span>`)
 * still yields its text, and returns `""` for anything with no textual content — an icon-only node,
 * `undefined`, or a component whose text only exists after it renders.
 */
export function getReactNodeText(node: ReactNode): string {
	if (typeof node === "string") return node;
	if (typeof node === "number") return node.toString();
	if (Array.isArray(node)) return node.map(getReactNodeText).join("");
	if (isValidElement<{ children?: ReactNode }>(node)) return getReactNodeText(node.props.children);
	return "";
}

export function isMobileDevice() {
	const userAgent = navigator.userAgent || navigator.vendor;
	return (
		/android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(40|60)|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|iPad/i.test(
			userAgent,
		) ||
		(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
	);
}
